import { defineMessages } from "react-intl";

export const messages = defineMessages({
  searchLabel: {
    id: "xmcVZ0",
    defaultMessage: "Search",
  },
  searchPlaceholder: {
    id: "ubd+Kj",
    defaultMessage: "Search by name…",
  },
  confirmBtn: {
    id: "gVqSnA",
    defaultMessage: "Assign and save",
  },
  titleProductTypes: {
    id: "YXhaCZ",
    defaultMessage: "Assign Product Types",
  },
  titleModelTypes: {
    id: "5ixtBQ",
    defaultMessage: "Assign Model Types",
  },
});
